import {fullScreenModalAction, modalKeyValueChangedAction, modalSetPosSizeAction, toggleModalAction} from 'module/Modal/action/ModalAction';
import {createReducer} from 'util/redux';
import {ModalState} from 'module/Modal/reducer/ModalType';
import {ModalKey} from 'module/Modal/type/ModalKey';

const ModalReducer = createReducer<{ [k in ModalKey]?: ModalState }>({}, builder => builder
	.addCase(modalSetPosSizeAction, (state, {payload}) => {
		const {modalKey} = payload;
		const subState = state[modalKey] || {};
		return {
			...state,
			[modalKey]: {
				...subState,
				position: payload.position || subState.position,
				size: payload.size || subState.size,
			},
		}
	})
	.addCase(toggleModalAction, (state, {payload}) => {
		const {modalKey, open} = payload;
		return {
			...state,
			[modalKey]: {
				...state[modalKey],
				open,
			},
		}
	})
	.addCase(fullScreenModalAction, (state, {payload}) => {
		const {modalKey, fullScreen} = payload;
		return {
			...state,
			[modalKey]: {
				...state[modalKey],
				fullScreen,
			},
		}
	})
	.addCase(modalKeyValueChangedAction, (state, {payload}) => {
		const {modalKey, key, value} = payload
		const kv = {
			...state[modalKey]?.kv,
			[key]: value,
		}
		return {
			...state,
			[modalKey]: {
				...state[modalKey],
				kv,
			},
		}
	}),
)
export const ModalReducerNS = {Modal: ModalReducer}
export type ModalStateType = { Modal: ReturnType<typeof ModalReducerNS.Modal> }